import { render, staticRenderFns } from "./ProposalFeed.vue?vue&type=template&id=2eb11f2e&"
import script from "./ProposalFeed.vue?vue&type=script&lang=js&"
export * from "./ProposalFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports